import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BankAccount } from 'app/models/dto/bank-account.model';
import { Observable, Subscription } from 'rxjs';

export interface DialogData {
  borrowerId: number;
  bankAccounts$: Observable<BankAccount[]>;
}

@Component({
  selector: 'app-bank-account-add-dialog',
  templateUrl: './bank-account-add-dialog.component.html',
  styleUrls: ['./bank-account-add-dialog.component.scss']
})
export class BankAccountAddDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<BankAccountAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
  }

  addAccount($event): void {
    this.dialogRef.close($event);
  }

  cancelDialog(): void {
    this.dialogRef.close();
  }

}
